import { ChangeDetectionStrategy, Component, output } from '@angular/core';

@Component({
  selector: 'app-login-gate',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="flex bg-brand-secondary flex-col items-center justify-center gap-6 flex-1 h-screen">
      <div class="flex flex-col items-center justify-center">
        <img src="/logos/logo_vertical_white.png" alt="Colmena" class="h-20" />
        <p class="max-w-[280px] text-center text-sm text-white/80">
          Portal de Prestadores — Colmena
        </p>

        <div>
          <div class="mx-auto mb-5 w-fit rounded-xl bg-surface px-6 py-3 shadow-sm md:hidden">
            <img src="/logos/logo_blue.png" alt="Isapre Colmena" class="block h-8" />
          </div>

          <div
            class="mx-auto w-[440px] max-w-[92vw] overflow-hidden rounded-sm bg-surface font-['Segoe_UI',Arial,sans-serif] shadow-[0_2px_6px_rgba(0,0,0,0.13),0_25px_55px_rgba(0,0,0,0.18)]"
          >
            <div class="px-11 pt-11 pb-[30px]">
              <div class="mb-[22px] flex items-center gap-2.5">
                <div class="grid h-[21px] w-[21px] grid-cols-2 grid-rows-2 gap-px">
                  <span class="block bg-[#f25022]"></span>
                  <span class="block bg-[#7fba00]"></span>
                  <span class="block bg-[#00a4ef]"></span>
                  <span class="block bg-[#ffb900]"></span>
                </div>
                <b class="text-[15px] font-normal text-[#1b1b1b]">Microsoft</b>
              </div>

              <div class="mb-1 text-2xl font-semibold text-heading-strong">Iniciar sesión</div>
              <div class="mb-6 text-[15px] text-text">
                para continuar a Portal de Prestadores — Colmena
              </div>

              <p class="mb-0 text-sm text-muted">
                Usa tu cuenta corporativa Colmena (Microsoft Entra ID) para acceder al portal.
              </p>

              <div class="mt-6 flex justify-end gap-2">
                <button
                  type="button"
                  class="rounded-[1px] bg-[#0067b8] px-7 py-2.5 text-[15px] font-normal text-white hover:bg-[#005a9e]"
                  (click)="continueLogin.emit()"
                >
                  Iniciar sesión con Microsoft
                </button>
              </div>
            </div>
            <div
              class="flex justify-between border-t border-border bg-bg px-11 py-3.5 text-xs text-muted"
            >
              <span>Términos de uso</span>
              <span>Privacidad y cookies</span>
              <span>Más información</span>
            </div>
          </div>

          <p class="mx-auto mt-4 max-w-[440px] text-center text-[11px] text-muted">
            Autenticación federada con Microsoft Entra ID · Isapre Colmena
          </p>
        </div>
      </div>
    </div>
  `,
})
export class LoginGateComponent {
  readonly continueLogin = output<void>();
}
